import React from "react";

/**
 * Class for notifications
 *
 * @param {Object} props
 * customClasses
 * text
 * @returns
 */
function Notifications(props) {
  let hasLink= props.hasLink || false;
  return (
    <div
      className={`notifications ${
        props.customClasses ? props.customClasses : ""
      }`}
    >
      {hasLink && 
        <a href={props.hasLink} target={'_blank'} rel={"noreferrer"}>
            <p>{props.text}</p>
        </a>
      }
      {hasLink === false && <p>{props.text}</p>}
    </div>
  );
}

export default Notifications;
